<div class="container mt-4">
  <!-- Tiêu đề với biểu tượng -->
  <h1 class="h3 mb-2 text-gray-800">
    <i class="fas fa-shopping-cart mr-2"></i> Đơn Hàng
  </h1>

  <!-- Mô tả dưới tiêu đề -->
  <p class="lead mb-4">
    Quản lý các đơn hàng của bạn từ phần này. Bạn có thể xem chi tiết tất cả các đơn hàng, thêm đơn hàng mới, chỉnh sửa hoặc xóa các đơn hàng hiện có. Sử dụng nút "Thêm Đơn Hàng" để tạo đơn hàng mới và quản lý tất cả các nhiệm vụ liên quan đến đơn hàng một cách hiệu quả.
  </p>

  <!-- Nút Thêm Đơn Hàng -->

  <!-- Bảng Đơn Hàng -->
  <div class="card mb-4">
    <div class="card-body">
      <div class="table-responsive">

        <button class="btn btn-outline-primary mb-3" (click)="openAddDialog()">Thêm Đơn Hàng</button>
        <button
          href="#"
          role="button"
          class="btn btn-outline-warning btn-icon-split"
          (click)="loadOrders()"
        >
          <span class="icon text-warning">
            <i class="fas fa-redo"></i>
          </span>
          <span class="text">Tải Lại</span>
        </button>
        <!-- Chỉ báo Đang Tải -->
        <div *ngIf="loadingIndicator; else loaded">
          <div class="d-flex justify-content-center">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Đang tải...</span>
            </div>
          </div>
        </div>

        <ng-template #loaded>
          <!-- ngx-datatable -->
          <ngx-datatable
            class="bootstrap"
            [rows]="orders"
            [headerHeight]="50"
            [footerHeight]="50"
            [rowHeight]="'auto'"
            [limit]="10"
            [loadingIndicator]="loadingIndicator"
            [reorderable]="true"
          >
            <!-- Cột Số Đơn Hàng -->
            <ngx-datatable-column name="Số Đơn Hàng" [prop]="'orderNumber'">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span style="color: red;">{{ row.orderNumber }}</span>
              </ng-template>
            </ngx-datatable-column>

            <!-- Cột Ngày Đặt Hàng -->
            <ngx-datatable-column name="Ngày Đặt Hàng" [prop]="'orderDate'">
              <ng-template ngx-datatable-cell-template let-row="row">
                {{ row.orderDate | date }}
              </ng-template>
            </ngx-datatable-column>

            <!-- Cột Nhà Cung Cấp -->
             <ngx-datatable-column name="Nhà Cung Cấp" [prop]="'vendor.name'">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span style="color: blue;">{{ row.vendor?.name }}</span>
              </ng-template>
            </ngx-datatable-column>

            <!-- Cột Tổng Chi Phí -->
            <ngx-datatable-column name="Tổng Chi Phí" [prop]="'totalCost'">
              <ng-template ngx-datatable-cell-template let-row="row">
                {{ row.totalCost | currency }}
              </ng-template>
            </ngx-datatable-column>

            <!-- Cột Trạng Thái -->
            <ngx-datatable-column name="Trạng Thái" [prop]="'status'">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span style="color: green;">{{ row.status }}</span>
              </ng-template>
            </ngx-datatable-column>

            <!-- Cột Ghi Chú -->
             <ngx-datatable-column name="Ghi Chú" [prop]="'notes'">
              <ng-template ngx-datatable-cell-template let-row="row">
                {{ row.notes }}
              </ng-template>
            </ngx-datatable-column> 

            <!-- Cột Hành Động -->
            <ngx-datatable-column name="Hành Động">
              <ng-template ngx-datatable-cell-template let-row="row">
                <button type="button" class="btn btn-outline-primary btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Hành Động
              </button>
              <div class="dropdown-menu">
                <a class="dropdown-item"  (click)="openEditDialog(row)">
                  <i class="fas fa-edit"></i> Chỉnh Sửa
                </a>
                <a class="dropdown-item"  (click)="deleteOrder(row.id)">
                  <i class="fas fa-trash"></i> Xóa
                </a>
                <a class="dropdown-item"  (click)="updateOrderStatus(row.id, 'Cancelled')">
                  <i class="fas fa-times-circle"></i> Đánh Dấu Đã Hủy
                </a>
                <a class="dropdown-item"  (click)="updateOrderStatus(row.id, 'Shipped')">
                  <i class="fas fa-truck"></i> Đánh Dấu Đã Gửi
                </a>
                <a class="dropdown-item"  (click)="updateOrderStatus(row.id, 'Delivered')">
                  <i class="fas fa-box-open"></i> Đánh Dấu Đã Giao
                </a>
                <a class="dropdown-item"  (click)="updateOrderStatus(row.id, 'Pending')">
                  <i class="fas fa-clock"></i> Đánh Dấu Đang Chờ
                </a>
              </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </ng-template>
      </div>
    </div>
  </div>
</div>
